import Message from 'components/Message';
import { PRODUCT_DETAILS_SIMILAR_PRODUCTS_ID } from 'constants/ids';
import { cn } from 'utils/classNames';
import { is } from 'utils/helpers';

import { useSimilarProductsContext } from './ProductDetailsContext';

interface Props {
	className?: string;
	expiredText: string;
	viewSimilarProductsLinkText: string;
}

export default function ExpiredProductInfo({
	className,
	expiredText,
	viewSimilarProductsLinkText,
}: Props) {
	const { items: similarProducts } = useSimilarProductsContext();
	return (
		<Message
			variant="information"
			className={cn('mx-auto mb-6 text-sm', className)}
			text={expiredText}
			link={
				is.arrayWithLength(similarProducts)
					? `#${PRODUCT_DETAILS_SIMILAR_PRODUCTS_ID}`
					: undefined
			}
			linkText={viewSimilarProductsLinkText}
		/>
	);
}
ExpiredProductInfo.displayName = 'ExpiredProductInfo';
